import React, { useLayoutEffect } from "react";
import { AppViews } from "pages/AppViews";
import { HeaderNav } from "layout/Header";
import classNames from "classnames";
import { Container } from "components/shared/Container";
import { Spinner } from "ui/Spinner";
import { useLocation } from "react-router-dom";

import LogoImg from "img/logo.png";
import { useLoading, useTamanoPantalla } from "contexts/providers";
import { esRutaTurbantes } from "constants/rutasTurbantes";

export const AppLayout: React.FC = () => {
  const { isLoading, titulo: tituloLoading } = useLoading();
  const { setTamanoPantalla } = useTamanoPantalla();
  const location = useLocation();

  // Ocultar logo en página de solicitud de presupuesto
  const ocultarLogo = location.pathname.includes('/solicitudPresupuesto');

  // La landing de turbantes trae su propio topbar y footer: el chrome del sitio se
  // duplicaría encima del suyo, además de exponer una navegación que esa página no
  // debe tener. Se suprime entero, no sólo el logo.
  const ocultarChrome = esRutaTurbantes(location.pathname);

  /**
   * Al montarse el componente chequeamos si se trata de mobile o web para
   * mostrar el layout apropiado
   */
  useLayoutEffect(() => {
    function updateSize(): void {
      setTamanoPantalla({ ancho: window.innerWidth, alto: window.innerHeight });
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);

    // setTamanoPantalla
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames("h-full scroll-smooth bg-white antialiased")}>
      {isLoading && <Spinner loading={isLoading} titulo={tituloLoading} />}
      {!ocultarChrome && <HeaderNav />}
      <div className="flex flex-col min-h-screen">
        <main className="flex-grow">
          <AppViews />
          {!ocultarChrome && !ocultarLogo && (
            <Container>
              <img
                src={LogoImg}
                alt="Logo al pie"
                className="w-2/5 md:w-1/4 lg:w-1/6 xl:w-1/12 mx-auto mt-16 mb-4"
              />
            </Container>
          )}
        </main>
        {!ocultarChrome && (
          <footer className="bg-gray-400 text-white text-center py-4">
            Floradibuja® 2024 - Córdoba, Argentina
          </footer>
        )}
      </div>
    </div>
  );
};
